function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "30 20 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 315.90614,49.446642 c -15.87894,-28.49012 -55.83516,-28.49012 -71.80039,0 L 37.075541,419.81818 c -15.878933,28.40109 3.969733,64.10277 35.900194,64.10277 H 487.12245 c 31.84416,0 51.77912,-35.61265 35.90019,-64.10277 z",
    id: "path112",
    style: {
      strokeWidth: 0.876544
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.8b235b57e593c9cd2ef45259a05cc8dd.svg";
export { ForwardRef as ReactComponent };